/**
 * Hub 'auth' events we are listening for
 */

export enum HUB_AUTH_EVENT {
  SIGN_IN = 'signIn',
  SIGN_IN_FAILURE = 'signIn_failure',
  SIGN_UP_FAILURE = 'signUp_failure',
  SIGN_OUT = 'signOut',
  // we don't use these events in our Hub listener — cataloging them for posterity
  // in case we do in the future
  SIGN_UP = 'signUp',
  FORGOT_PASSWORD = 'forgotPassword',
  FORGOT_PASSWORD_SUBMIT = 'forgotPasswordSubmit',
  FORGOT_PASSWORD_SUBMIT_FAILURE = 'forgotPasswordSubmit_failure',
}
